import React from "react";

const NewChatIcon = ({ color = "#A8ABAC" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0_16145_14809)">
      <path
        d="M7.5 16.3285C6.91422 16.1911 6.36349 15.9763 5.83152 15.7019C5.45405 15.5072 5.01777 15.4447 4.61096 15.5667L2.83412 16.0998C2.26202 16.2714 1.7286 15.738 1.90024 15.1659L2.43328 13.3891C2.55533 12.9822 2.49284 12.5459 2.29813 12.1684C1.8016 11.2059 1.5 10.1819 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C12.4947 1.5 15.2924 3.8902 16.125 7.125"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.375 16.5C10.0968 16.5 8.25 14.6532 8.25 12.375C8.25 10.0968 10.0968 8.25 12.375 8.25C14.6532 8.25 16.5 10.0968 16.5 12.375C16.5 13.025 16.3341 13.5883 16.061 14.1177C15.9539 14.3253 15.9196 14.5652 15.9867 14.7889L16.2799 15.7662C16.3743 16.0809 16.0809 16.3743 15.7662 16.2799L14.7889 15.9867C14.5652 15.9196 14.3253 15.9539 14.1177 16.061C13.5883 16.3341 13.025 16.5 12.375 16.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16145_14809">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default NewChatIcon;
